import React from 'react';
import { Box, Typography } from '@mui/material';

interface EmptyStateProps {
  img: string;
  header: string;
  text: string;
  sx?: any;
}

export const EmptyState = (
  {
    img,
    header,
    text,
    sx,
  } : EmptyStateProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ...sx
      }}
    >
      <img
        src={img}
        style={{
          height: 264,
          objectFit: 'contain',
          marginBottom: '32px',
        }}
      />
      <Box sx={{maxWidth: '560px',}}>
        <Typography sx={{
          fontSize: '18px',
          fontWeight: 600,
          color: 'black',
          textAlign: 'center',
        }}>
          {header}
        </Typography>

        <Typography sx={{
          paddingTop: '16px',
          fontSize: '18px',
          fontWeight: 400,
          color: 'black',
          textAlign: 'center',
        }}>
          {text}
        </Typography>
      </Box>

    </Box>
  );
}
